// extracted by mini-css-extract-plugin
export default {"main":"FlashCards_main__e5YXQ"};